import _ from "lodash";
import { Types } from "../actions/organisationActions";

//import { v4 as uuidv4 } from 'uuid';

const defaultState = {
  costCenter: {}
};

const organisationReducers = (state = defaultState, action) => {
  switch (action.type) {
    case Types.ORGANISATION_GET: {

      let newState = _.cloneDeep(state);

      newState.organisation = action.payload
      newState.organisation.loading = false;

      console.log('getOrg',newState.organisation)

      return newState;
    }
    case Types.ORGANISATION_LOADING: {

      let newState = _.cloneDeep(state);

      newState.organisation.loading = true;

      return newState;
    }
    default:
      return state;
  }
};

export default organisationReducers;